import { useEffect, useState } from "react";
import api from "../../lib/api";
import { usePublic } from "../../components/PublicLayout";
import { PricingSection, HowItWorksSection, FaqSection, FinalCta } from "../../components/sections";
import { Reveal } from "../../components/Reveal";

export default function Pricing() {
  const { settings } = usePublic();
  const [packages, setPackages] = useState([]);
  const [addons, setAddons] = useState([]);
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/content/pricing").then(({ data }) => setPackages(data));
    api.get("/content/addons").then(({ data }) => setAddons(data));
    api.get("/content/faqs").then(({ data }) => setFaqs(data));
  }, []);
  return (
    <>
      <section className="pt-36 pb-4 px-5 sm:px-8" data-testid="pricing-page">
        <div className="max-w-4xl mx-auto text-center">
          <Reveal>
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-orange">Fixed-price packages</span>
            <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-6xl text-brand-purpleDeep leading-tight">
              Fixed packages. Fast delivery.
            </h1>
            <p className="mt-5 text-lg text-brand-purpleDeep/60">
              Transparent, fixed-price video packages — from $999. Pick one, build your quote and book your shoot online.
            </p>
          </Reveal>
        </div>
      </section>
      <PricingSection packages={packages} addons={addons} settings={settings} />
      <HowItWorksSection />
      <FaqSection faqs={faqs} />
      <FinalCta settings={settings} />
    </>
  );
}
